
import XHeader from 'vux/src/components/x-header/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Divider from 'vux/src/components/divider/index.vue'


export default {
components: {
XHeader,
Tab,
TabItem,
Divider
},
data () {
return {
tabIndex:0,
pathCur:0,
}
},
methods: {

}
}



// WEBPACK FOOTER //
// ./src/views/saas/detail.vue